import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useState, useEffect } from 'react';
import TokenWatcher from './TokenWatcher';
import Navbar from './Navbar/Navbar';
import Sidebar from './sidebar/Sidebar';
import LoginPage from './Login/LoginPage';
import AuthorizedRoute from './utils/AuthorizedRoute';
import Footer from './Footer/Footer';
import BenefitList from './PlayingPlan/BenefitList';
import UserList from './UserRole/UserList';
import RoleList from './UserRole/RoleList';
import CreateRolePage from './UserRole/CreateRolePage';
import CreateUserPage from './UserRole/CreateUserPage';
import AcademyList from './Academy/AcademyList';
import DisabledAcademy from './Academy/DisableAcademy';
import NewAcademy from './Academy/NewAcademy';
import SportList from './sport/SportList';
import NewSport from './sport/NewSport';
import CouponList from './coupons/CouponList';
import NewCoupon from './coupons/NewCoupon';
import Dues from './Payment/Dues';
import PaymentList from './Payment/PaymentList';
import SportPayment from './Payment/SportPayment';
import Summary from './Payment/Summary';
import AcademyPlayerList from './Coaching/AcademyPlayerList';
import AcademyCoachList from './Coaching/AcademyCoachList';
import NewPlayer from './Coaching/NewPlayer';
import NewBatch from './Coaching/NewBatch';
import BatchList from './Coaching/BatchList';
import PlayerBatch from './Coaching/PlayerBatch';
import BatchCancellation from './Coaching/BatchCancellation';
import CancelBatchList from './Coaching/CancelBatchList';
import NewPlan from './PlayingPlan/NewPlan';
import PlanList from './PlayingPlan/PlanList';
import BlockCourt from './CourtBooking/BlockCourt';
import BookingCalendar from './CourtBooking/BookingCalendar';
import BulkBookingList from './CourtBooking/BulkBookingList';
import CourtList from './CourtBooking/CourtList';
import CourtPrice from './CourtBooking/CourtPrice';
import NewCourt from './CourtBooking/NewCourt';
import CourtBookings from './CourtBooking/CourtBookings';
import CourtBulkBooking from './CourtBooking/CourtBulkBooking';
import AcademyGallery from './AcademyProfile/AcademyGallery';
import BankDetails from './AcademyProfile/BankDetails';
import EditProfile from './AcademyProfile/EditProfile';
import ResetPassword from './AcademyProfile/ResetPassword';
import FeesSetting from './AcademyProfile/FeesSetting';
import RazorPayauth from './RazorPay/RazorPayauth';
import SearchUser from './Checkin/SearchUser';
import CheckinReports from './Reports/CheckinReports';
import CouponsUsageReport from './Reports/CouponsUsageReport';
import LearnTrailReports from './Reports/LearnTrailReports';
import LeaveReport from './Reports/LeaveReport';
import LoginReport from './Reports/LoginReport';
import PlayingSubscription from './Reports/PlayingSubscription';
import PlayTrailReport from './Reports/PlayTrailReport';
import SalesRegister from './Reports/SalesRegister';
import { UserProvider } from './context/UserContext';
import ProgressAttribute from './sport/ProgressAttribute';
import NewProgress from './sport/NewProgress';
import AttributeQA from './sport/AttributeQA';
import ProgressParamter from './sport/Progressparameter';
import NewAttributeQA from './sport/NewAttributeQA'
import NewProgessParameter from './sport/NewProgessParameter';
import SettlePayment from './Payment/SettlePayment';
import CreatePlayer from './Coaching/CreatePlayer';
import Shop from './Coaching/Shop';
import UnavailableDate from './CourtBooking/UnavailableDate';
import AddUnavailableDate from './CourtBooking/AddUnavailableDate';
import CheckinDetails from './Checkin/CheckinDetails';
import SetGuardian from './Coaching/SetGuardian';
import PlayerAttendance from './Coaching/PlayerAttendance';
import PlayerPaymentDetail from './Coaching/PlayerPaymentDetail';
import Dashboard from './Marketing/Dashboard';
import Coldleads from './Marketing/ Coldleads';
import Trialrescheduled from './Marketing/Trialrescheduled';
import Trailattended from './Marketing/Trialattended';
import Trialmissed from './Marketing/Trialmissed';
import Trialconverted from './Marketing/Trialconverted';
import Enquiry from './Marketing/Enquiry';
import Summer from './Marketing/Summer';
import SummerColdLead from './Marketing/SummerColdLead';
import Profile from './Login/Profile';
import BookingConfirmation from './CourtBooking/BookingConfirmation';
import DetailAttedanceList from './Coaching/DetailAttedanceList';
import BatchPlayerList from './Coaching/BatchPlayerList';
import Performance from './Coaching/Performance';
import NewPerformance from './Coaching/NewPerformance';
import CoachFeedback from './CBU/CoachFeedback';
import CoachList from './CBU/CoachList';
import CreateCoach from './CBU/CreateCoach';
import Dropouts from './CBU/Dropouts';
import NewEnrollments from './CBU/NewEnrollments';
import UserFeedback from './CBU/UserFeedback';
import CreateBenfits from './PlayingPlan/CreateBenfits';
import ViewCurriculum from './CTU/ViewCurriculum';
import Drills from './sport/Drills';
import Category from './sport/Category';
import NewCategory from './sport/NewCategory';
import NewDrills from './sport/NewDrills';
import SetPlayer from './Coaching/SetPlayer';
import MainDashboard from './pages/Dashboard';
import ViewPerformance from './Coaching/ViewPerformance';
import GuardianPlayer from './Coaching/GuardianPlayer';
import AddPlayerBatch from './Coaching/AddPlayerBatch';
import PlayerCoachlist from './CBU/ PlayerCoachlist';
import Activeplayer from './CBU/Activeplayer';
import AddPlayerPayment from './Coaching/AddPlayerPayment';
import WalkInFormEnquiry from './Centre Management/WalkInFormEnquiry';
import WalkinEnuiry from './Centre Management/WalkinEnquiry';
import WalkInEnrollment from './Centre Management/WalkInEnrollment';
import ZincoDashboard from './Centre Management/ZincoDashboard';
import SummerEnrollmentForm from './Centre Management/SummerEnrollmentForm';
import WalkInSales from './Centre Management/WalkInSales';
import DailyRevenueReport from './Centre Management/DailyRevenueReport';
import DailyUtlisationReport from './Centre Management/DailyUtilisationReport';
import CoachingEnrollment from './Centre Management/WalkinRecord';
import CashTracking from './Centre Management/CashTracking';
import Guest from './Guest/Guest';
import Family from './GlobalSearch/Family';
import PlayerDetails from './GlobalSearch/PlayerDetails';
import TaskTracking from './TrackingTask/TaskTracking';
import NewSearch from './GlobalSearch/ActivityLogs';
import CreateMachaxiPass from './PlayingPlan/CreateMachaxiPass';
import MachaxiPass from './PlayingPlan/MachaxiPass';
import TierCreation from './Academy/TierCreation';
import TierList from './Academy/TierList';
import BackToTopButton from './sidebar/BackToTopButton';
import NewSportBenefit from './sport/NewSportBenefit';
import CourtPrice2 from './CourtBooking/NewCourtPricing';
import CourtPricingNew from './CourtBooking/CourtPricingNew';
import AcademyFeatures from './Academy/AcademyFeatures';
import NewAcademyFeatures from './Academy/NewAcademyFeatures';
import CourtType from './sport/CourtType';
import OldNewPlan from './PlayingPlan/OldNewPlan';
import OldPlanList from './PlayingPlan/OldPlanList';
import Ticket from './Ticket/Ticket';
import CreateTicket from './Ticket/CreateTicket';
import EmployeeCreation from './Ticket/EmployeeCreation';
import Employee from './Ticket/Employee';
import SubCategory from './Ticket/SubCategory';
import TCategory from './Ticket/Category';
import SubCategoryCreation from './Ticket/SubCategoryCreation';
import CategoryCreation from './Ticket/CategoryCreation';
import TicketingReportPage from './Ticket/TicketReport';
import CareerPage from './Reports/CareerPage';
import CoachAttendance from './CBU/CoachAttendance';
import PlayingSubNew from './Reports/PlayingSubNew';
import CmTeamRevenue from './Centre Management/CmTeamRevenue';
import PerCourtUtilization from './Centre Management/PerCourtUtilization';
import CourtCreationNew from './CourtBooking/CourtCreationNew';
import Employeehr from './HR/Employeehr';
import DepartmentAndJobFunction from './HR/DepartmentAndJobFunction';
import EmployeeAttendance from './HR/EmployeeAttendance';
import DepartmentAndRolesCreation from './HR/DepartmentAndRolesCreation';
import EmployeehrCreation from './HR/EmployeehrCreation';
import UserReward from './Centre Management/UserReward';
import WinterSales from './Reports/WinterSales';
import ReconciliationReport from './Centre Management/ReconciliationReport';
function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const handleSidebarToggle = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };
  useEffect(() => {
    const loggedInStatus = localStorage.getItem('isLoggedIn');
    if (loggedInStatus === 'true') {
      setIsLoggedIn(true);
    }
  }, []);

  const handleLogin = () => {
    setIsLoggedIn(true);
    localStorage.setItem('isLoggedIn', 'true');
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('selectedCenter');
  };
  const getContentMaxWidth = () => {
    const isMobile = window.innerWidth <= 768;
    const collapsedWidth = isMobile ? 70 : 60;
    const expandedWidth = isMobile ? 70 : 210;

    return `calc(100vw - ${isSidebarCollapsed ? collapsedWidth : expandedWidth}px)`;
  };

  return (
    <UserProvider>
      <Router>
        {isLoggedIn ? (
          <>
            <TokenWatcher setIsLoggedIn={setIsLoggedIn} />
            <Navbar onLogout={handleLogout} />
            <div style={{ display: 'flex' }}>
              <Sidebar isCollapsed={isSidebarCollapsed} onToggle={handleSidebarToggle} />
              <div
                style={{
                  flexGrow: 1,
                  padding: '10px',
                  maxWidth: getContentMaxWidth(),
                }}
              >
                <Routes>
                  <Route path="/" element={<MainDashboard />} />
                  <Route path="/academyFeatures" element={<AcademyFeatures />} />
                  <Route path="/newAcademyFeatures" element={<NewAcademyFeatures />} />
                  <Route path="/courtPricing" element={<CourtPricingNew />} />
                  <Route path="/courtType" element={<CourtType />} />
                  <Route path="/createCourtPricing" element={<CourtPrice2 />} />
                  <Route path="/benfit" element={<BenefitList />} />
                  <Route path="/createbenefit" element={<CreateBenfits />} />
                  <Route path="/oldPlanList" element={<OldPlanList />} />
                  <Route path="/oldPlan" element={<OldNewPlan />} />
                  <Route path="/ActivityLog" element={<NewSearch />} />
                  <Route path="/sportBenefit" element={<NewSportBenefit />} />
                  <Route path="/createPass" element={<CreateMachaxiPass />} />
                  <Route path="/passList" element={<MachaxiPass />} />
                  <Route path="/tierCreation" element={<TierCreation />} />
                  <Route path="/tierList" element={<TierList />} />
                  <Route path="/newTicket" element={<CreateTicket />} />
                  <Route path="/createEmployee" element={<EmployeeCreation />} />
                  <Route path="/ticketSubCategory" element={<SubCategory />} />
                  <Route path="/SubCategoryCreation" element={<SubCategoryCreation />} />
                  <Route path="/CategoryCreation" element={<CategoryCreation />} />
                  <Route path="/courtCreation" element={<CourtCreationNew />} />
                  <Route path="/departmentAndJob" element={<DepartmentAndJobFunction />} />
                  <Route path="/departmentAndRolesCreation" element={<DepartmentAndRolesCreation />} />
                  <Route path="/employeeHr" element={<Employeehr />} />
                  <Route path="/employeeHrReport" element={<EmployeeAttendance />} />
                  <Route path="/employeeCreation" element={<EmployeehrCreation />} />
                  <Route path="/winterSales" element={<WinterSales />} />
                  <Route path="/userRewards" element={<UserReward />} />
                  <Route
                    path="/reconciliationReport"
                    element={
                      <AuthorizedRoute section="CENTRE_MANAGEMENT" permission="RECONCILIATION_REPORT_VIEW">
                        <ReconciliationReport />
                      </AuthorizedRoute>
                    }
                  />
                  <Route
                    path="/cmTeamRevenue"
                    element={
                      <AuthorizedRoute section="CENTRE_MANAGEMENT" permission="CM_TEAM_REVENUE">
                        <CmTeamRevenue />
                      </AuthorizedRoute>
                    }
                  />
                  <Route
                    path="/perCourtUtilization"
                    element={
                      <AuthorizedRoute section="CENTRE_MANAGEMENT" permission="PER_COURT_UTILIZATION_VIEW">
                        <PerCourtUtilization />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/careerApplications"
                    element={
                      <AuthorizedRoute section="REPORTS" permission="CAREER_APPLICATIONS_VIEW">
                        <CareerPage />
                      </AuthorizedRoute>
                    }
                  />
                  <Route
                    path="/coachAttendance"
                    element={
                      <AuthorizedRoute section="CBU" permission="COACH_ATTENDANCE_VIEW">
                        <CoachAttendance />
                      </AuthorizedRoute>
                    }
                  />
                  <Route
                    path="/ticketReport"
                    element={
                      <AuthorizedRoute section="TICKET" permission="TICKET_REPORT_VIEW">
                        <TicketingReportPage />
                      </AuthorizedRoute>
                    }
                  />
                  <Route
                    path="/employee"
                    element={
                      <AuthorizedRoute section="TICKET" permission="EMPLOYEE_VIEW">
                        <Employee />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/ticketcategory"
                    element={
                      <AuthorizedRoute section="TICKET" permission="TICKET_CATEGORY_VIEW">
                        <TCategory />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/ticket"
                    element={
                      <AuthorizedRoute section="TICKET" permission="TICKETS_VIEW">
                        <Ticket />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/UserList"
                    element={
                      <AuthorizedRoute section="USER_ROLE" permission="USER_LIST_VIEW">
                        <UserList />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/RoleList"
                    element={
                      <AuthorizedRoute section="USER_ROLE" permission="ROLE_LIST_VIEW">
                        <RoleList />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/create-user"
                    element={
                      <AuthorizedRoute section="USER_ROLE" permission="USER_LIST_MODIFY">
                        <CreateUserPage />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/create-role"
                    element={
                      <AuthorizedRoute section="USER_ROLE" permission="ROLE_LIST_MODIFY">
                        <CreateRolePage />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/academylist"
                    element={
                      <AuthorizedRoute section="ACADEMY" permission="ACADEMY_LIST_VIEW">
                        <AcademyList />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/disabledAcademy"
                    element={
                      <AuthorizedRoute section="ACADEMY" permission="DISABLED_ACADEMY_LIST_VIEW">
                        <DisabledAcademy />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/newAcademy"
                    element={
                      <AuthorizedRoute section="ACADEMY" permission="CREATE_NEW_ACADEMY_VIEW">
                        <NewAcademy />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/sportList"
                    element={
                      <AuthorizedRoute section="SPORTS" permission="SPORT_LIST_VIEW">
                        <SportList />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/newSport"
                    element={
                      <AuthorizedRoute section="SPORTS" permission="CREATE_NEW_SPORT_VIEW">
                        <NewSport />
                      </AuthorizedRoute>
                    }
                  />


                  <Route
                    path="/coupon"
                    element={
                      <AuthorizedRoute section="COUPONS" permission="COUPONS_LIST_VIEW">
                        <CouponList />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/newCoupon"
                    element={
                      <AuthorizedRoute section="COUPONS" permission="CREATE_NEW_COUPON">
                        <NewCoupon />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/paymentlist"
                    element={
                      <AuthorizedRoute section="PAYMENT" permission="PAYMENT_LIST_VIEW">
                        <PaymentList />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/dues"
                    element={
                      <AuthorizedRoute section="PAYMENT" permission="PAYMENT_DUES_VIEW">
                        <Dues />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/summary"
                    element={
                      <AuthorizedRoute section="PAYMENT" permission="PAYMENT_SUMMARY_VIEW">
                        <Summary />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/sportPaymentsummary"
                    element={
                      <AuthorizedRoute section="PAYMENT" permission="SPORTS_PAYMENT_SUMMARY_VIEW">
                        <SportPayment />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/academyPlayerList"
                    element={
                      <AuthorizedRoute section="COACHING" permission="ACADEMY_PLAYER_LIST_VIEW">
                        <AcademyPlayerList />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/academyCoachList"
                    element={
                      <AuthorizedRoute section="COACHING" permission="ACADEMY_COACH_LIST_VIEW">
                        <AcademyCoachList />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/createNewBatch"
                    element={
                      <AuthorizedRoute section="COACHING" permission="CREATE_NEW_BATCH_VIEW">
                        <NewBatch />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/createNewPlayer"
                    element={
                      <AuthorizedRoute section="COACHING" permission="CREATE_NEW_PLAYER_VIEW">
                        <NewPlayer />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/batchList"
                    element={
                      <AuthorizedRoute section="COACHING" permission="BATCH_LIST_VIEW">
                        <BatchList />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/playerBatch"
                    element={
                      <AuthorizedRoute section="COACHING" permission="PLAYER_BATCHES_VIEW">
                        <PlayerBatch />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/batchCancellation"
                    element={
                      <AuthorizedRoute section="COACHING" permission="BATCH_CANCELLATION_VIEW">
                        <BatchCancellation />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/cancelBatchList"
                    element={
                      <AuthorizedRoute section="COACHING" permission="CANCELLED_BATCHES_VIEW">
                        <CancelBatchList />
                      </AuthorizedRoute>
                    }
                  />


                  <Route
                    path="/planList"
                    element={
                      <AuthorizedRoute section="PLAYING_PLAN" permission="PLANS_LIST_VIEW">
                        <PlanList />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/newPlan"
                    element={
                      <AuthorizedRoute section="PLAYING_PLAN" permission="CREATE_PLAN_VIEW">
                        <NewPlan />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/courtlist"
                    element={
                      <AuthorizedRoute section="COURTS" permission="COURT_LIST_VIEW">
                        <CourtList />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/bookingcalendar"
                    element={
                      <AuthorizedRoute section="COURTS" permission="BOOKING_CALENDAR_VIEW">
                        <BookingCalendar />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/courtbookings"
                    element={
                      <AuthorizedRoute section="COURTS" permission="COURT_BOOKINGS_VIEW">
                        <CourtBookings />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/courtprice"
                    element={
                      <AuthorizedRoute section="COURTS" permission="COURT_PRICING_VIEW">
                        <CourtPrice />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/courtbulkbooking"
                    element={
                      <AuthorizedRoute section="COURTS" permission="COURT_BULK_BOOKING_VIEW">
                        <CourtBulkBooking />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/bulkbookinglist"
                    element={
                      <AuthorizedRoute section="COURTS" permission="BULK_BOOKING_LIST_VIEW">
                        <BulkBookingList />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/newcourt"
                    element={
                      <AuthorizedRoute section="COURTS" permission="ADD_NEW_COURT_VIEW">
                        <NewCourt />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/blockcourt"
                    element={
                      <AuthorizedRoute section="COURTS" permission="BLOCK_COURT_LIST_VIEW">
                        <BlockCourt />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/editprofile"
                    element={
                      <AuthorizedRoute section="ACADEMY_PROFILE" permission="EDIT_PROFILE_VIEW">
                        <EditProfile />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/bankdetails"
                    element={
                      <AuthorizedRoute section="ACADEMY_PROFILE" permission="BANK_DETAILS_VIEW">
                        <BankDetails />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/feesSetting"
                    element={
                      <AuthorizedRoute section="ACADEMY_PROFILE" permission="FEES_SETTINGS_VIEW">
                        <FeesSetting />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/academygallery"
                    element={
                      <AuthorizedRoute section="ACADEMY_PROFILE" permission="ACADEMY_GALLERY_VIEW">
                        <AcademyGallery />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/resetPassword"
                    element={
                      <AuthorizedRoute section="ACADEMY_PROFILE" permission="RESET_PASSWORD_VIEW">
                        <ResetPassword />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/razorpayauth"
                    element={
                      <AuthorizedRoute section="RAZORPAY_AUTHORIZATION" permission="RAZORPAY_AUTHORIZATION_VIEW">
                        <RazorPayauth />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/searchuser"
                    element={
                      <AuthorizedRoute section="ATTENDANCE_VIEW" permission="CHECKIN_ATTENDANCE_VIEW">
                        <SearchUser />
                      </AuthorizedRoute>
                    }
                  />
                  <Route
                    path="/loginreport"
                    element={
                      <AuthorizedRoute section="REPORTS" permission="LOGIN_REPORT_VIEW">
                        <LoginReport />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/couponsusagereport"
                    element={
                      <AuthorizedRoute section="REPORTS" permission="COUPONS_USAGE_REPORT_VIEW">
                        <CouponsUsageReport />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/playtrailreport"
                    element={
                      <AuthorizedRoute section="REPORTS" permission="PLAY_TRIAL_REPORT_VIEW">
                        <PlayTrailReport />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/learntrailreports"
                    element={
                      <AuthorizedRoute section="REPORTS" permission="LEARN_TRIAL_REPORT_VIEW">
                        <LearnTrailReports />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/checkinreport"
                    element={
                      <AuthorizedRoute section="REPORTS" permission="CHECKIN_REPORT_VIEW">
                        <CheckinReports />
                      </AuthorizedRoute>
                    }
                  />
                  <Route
                    path="/newPlayingSubscription"
                    element={
                      <AuthorizedRoute section="REPORTS" permission="PLAYING_SUBSCRIPTIONS_VIEW">
                        <PlayingSubNew />
                      </AuthorizedRoute>
                    }
                  />
                  <Route
                    path="/playingsubscription"
                    element={
                      <AuthorizedRoute section="REPORTS" permission="PLAYING_SUBSCRIPTIONS_VIEW">
                        <PlayingSubscription />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/leavereport"
                    element={
                      <AuthorizedRoute section="REPORTS" permission="LEAVE_REPORT_VIEW">
                        <LeaveReport />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/salesRegister"
                    element={
                      <AuthorizedRoute section="REPORTS" permission="SALES_REGISTER_VIEW">
                        <SalesRegister />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/ProgresAttribute"
                    element={
                      <AuthorizedRoute section="SPORTS" permission="SPORT_LIST_MODIFY">
                        <ProgressAttribute />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/newProgress"
                    element={
                      <AuthorizedRoute section="SPORTS" permission="SPORT_LIST_MODIFY">
                        <NewProgress />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/AttributeQa"
                    element={
                      <AuthorizedRoute section="SPORTS" permission="SPORT_LIST_MODIFY">
                        <AttributeQA />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/ProgessParameter"
                    element={
                      <AuthorizedRoute section="SPORTS" permission="SPORT_LIST_MODIFY">
                        <ProgressParamter />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/newAttribute"
                    element={
                      <AuthorizedRoute section="SPORTS" permission="SPORT_LIST_MODIFY">
                        <NewAttributeQA />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/newProgessParameter"
                    element={
                      <AuthorizedRoute section="SPORTS" permission="SPORT_LIST_MODIFY">
                        <NewProgessParameter />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/settlePayment"
                    element={
                      <AuthorizedRoute section="PAYMENT" permission="PAYMENT_DUES_MODIFY">
                        <SettlePayment />
                      </AuthorizedRoute>
                    }
                  />

                  <Route path="/createplayer" element={<CreatePlayer />} />
                  <Route path="/shop" element={<Shop />} />

                  <Route path="/unavailableDate" element={<UnavailableDate />} />
                  <Route path="/addunavailableDate" element={<AddUnavailableDate />} />

                  <Route path="/checkinDetails" element={<CheckinDetails />} />

                  <Route path="/setGuardian" element={<SetGuardian />} />
                  <Route path="/playerAttendance" element={<PlayerAttendance />} />
                  <Route path="/playerpaymentDetail" element={<PlayerPaymentDetail />} />

                  <Route
                    path="/dashboard"
                    element={
                      <AuthorizedRoute section="MARKETING" permission="ALL_LEADS_VIEW">
                        <Dashboard />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/Trialattended"
                    element={
                      <AuthorizedRoute section="MARKETING" permission="TRIAL_ATTENDED_VIEW">
                        <Trailattended />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/Trialmissed"
                    element={
                      <AuthorizedRoute section="MARKETING" permission="TRIAL_MISSED_VIEW">
                        <Trialmissed />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/Trialrescheduled"
                    element={
                      <AuthorizedRoute section="MARKETING" permission="TRIAL_RESCHEDULED_VIEW">
                        <Trialrescheduled />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/Trialconverted"
                    element={
                      <AuthorizedRoute section="MARKETING" permission="TRIAL_CONVERTED_VIEW">
                        <Trialconverted />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/coldleads"
                    element={
                      <AuthorizedRoute section="MARKETING" permission="JUNK_LEADS_VIEW">
                        <Coldleads />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/Summer"
                    element={
                      <AuthorizedRoute section="MARKETING" permission="SUMMER_ENROLLMENTS_VIEW">
                        <Summer />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/SummerColdLead"
                    element={
                      <AuthorizedRoute section="MARKETING" permission="DROPOFFS_OF_SUMMER_CAMP_VIEW">
                        <SummerColdLead />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/Enquiry"
                    element={
                      <AuthorizedRoute section="MARKETING" permission="EQUIRY_VIEW">
                        <Enquiry />
                      </AuthorizedRoute>
                    }
                  />


                  <Route path="/profile" element={<Profile />} />

                  <Route path="/bookingConfirmation" element={<BookingConfirmation />} />

                  <Route path="/detailsAttendance" element={<DetailAttedanceList />} />
                  <Route path="/batchPlayerList" element={<BatchPlayerList />} />
                  <Route path="/performance" element={<Performance />} />
                  <Route path="/newPerformance" element={<NewPerformance />} />

                  <Route
                    path="/coachFeedback"
                    element={
                      <AuthorizedRoute section="CBU" permission="COACH_FEEDBACK_VIEW">
                        <CoachFeedback />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/coachList"
                    element={
                      <AuthorizedRoute section="CBU" permission="COACH_LIST_VIEW">
                        <CoachList />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/createCoach"
                    element={
                      <AuthorizedRoute section="CBU" permission="CREATE_COACH_MODIFY">
                        <CreateCoach />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/dropouts"
                    element={
                      <AuthorizedRoute section="CBU" permission="DROPOUTS_VIEW">
                        <Dropouts />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/newEnrollments"
                    element={
                      <AuthorizedRoute section="CBU" permission="NEW_ENROLLMENTS_VIEW">
                        <NewEnrollments />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/userFeedback"
                    element={
                      <AuthorizedRoute section="CBU" permission="USER_FEEDBACK_VIEW">
                        <UserFeedback />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/playerCoachList"
                    element={
                      <AuthorizedRoute section="CBU" permission="PLAYER_COACH_LIST_VIEW">
                        <PlayerCoachlist />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/activePlayer"
                    element={
                      <AuthorizedRoute section="CBU" permission="ACTIVE_PLAYER_VIEW">
                        <Activeplayer />
                      </AuthorizedRoute>
                    }
                  />


                  <Route
                    path="/Curriculum"
                    element={
                      <AuthorizedRoute section="CTU" permission="CURRICULUM_VIEW">
                        <ViewCurriculum />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/category"
                    element={
                      <AuthorizedRoute section="SPORTS" permission="SPORT_LIST_MODIFY">
                        <Category />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/drills"
                    element={
                      <AuthorizedRoute section="SPORTS" permission="SPORT_LIST_MODIFY">
                        <Drills />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/createDrills"
                    element={
                      <AuthorizedRoute section="SPORTS" permission="SPORT_LIST_MODIFY">
                        <NewDrills />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/createCategory"
                    element={
                      <AuthorizedRoute section="SPORTS" permission="SPORT_LIST_MODIFY">
                        <NewCategory />
                      </AuthorizedRoute>
                    }
                  />

                  <Route path="/setPlayer" element={<SetPlayer />} />
                  <Route path="/viewPerformance" element={<ViewPerformance />} />
                  <Route path="/setGuardianPlayer" element={<GuardianPlayer />} />
                  <Route path="/addPlayerBatch" element={<AddPlayerBatch />} />
                  <Route path="/addPlayerPayment" element={<AddPlayerPayment />} />

                  <Route
                    path="/walkInFormEnquiry"
                    element={
                      <AuthorizedRoute section="CENTRE_MANAGEMENT" permission="WALK_IN_ENQUIRY_FORM_VIEW">
                        <WalkInFormEnquiry />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/walkinenquiry"
                    element={
                      <AuthorizedRoute section="CENTRE_MANAGEMENT" permission="WALK_IN_ENQUIRY_VIEW">
                        <WalkinEnuiry />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/courtlights"
                    element={
                      <AuthorizedRoute section="CENTRE_MANAGEMENT" permission="COURT_LIGHT_VIEW">
                        <ZincoDashboard />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/walkInSales"
                    element={
                      <AuthorizedRoute section="CENTRE_MANAGEMENT" permission="WALK_IN_SALES_VIEW">
                        <WalkInSales />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/dailyRevenueReport"
                    element={
                      <AuthorizedRoute section="CENTRE_MANAGEMENT" permission="DAILY_REVENUE_VIEW">
                        <DailyRevenueReport />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/dailyUtilisationReport"
                    element={
                      <AuthorizedRoute section="CENTRE_MANAGEMENT" permission="DAILY_UTILIZATION_VIEW">
                        <DailyUtlisationReport />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/walkInSalesRecords"
                    element={
                      <AuthorizedRoute section="CENTRE_MANAGEMENT" permission="WALK_IN_SALES_RECORD_VIEW">
                        <CoachingEnrollment />
                      </AuthorizedRoute>
                    }
                  />

                  <Route
                    path="/cashTracking"
                    element={
                      <AuthorizedRoute section="CENTRE_MANAGEMENT" permission="CASH_TRACKING_VIEW">
                        <CashTracking />
                      </AuthorizedRoute>
                    }
                  />

                  <Route path="/guestUser" element={<Guest />} />
                  <Route path="/playerDetails" element={<PlayerDetails />} />
                  <Route path="/family" element={<Family />} />
                  <Route
                    path="/taskTracking"
                    element={
                      <AuthorizedRoute section="ACTIVITY_TRACKING" permission="ACTIVITY_TRACKING_VIEW">
                        <TaskTracking />
                      </AuthorizedRoute>
                    }
                  />
                </Routes>

              </div>

            </div>
            <BackToTopButton />
            <Footer />
          </>
        ) : (
          <LoginPage setIsLoggedIn={handleLogin} />
        )}
      </Router>
    </UserProvider>
  );
}

export default App;